import styled from "@emotion/styled";
import { Card } from "@mui/material";

export const ViewCampaignsSkeletonWrapper = styled.div({
	margin: "16px",
	display: "flex",
	flexDirection: "column",
	gap: "2px"
});

export const CampaignSkeletonCard = styled(Card)({
	borderRadius: "unset"
});
